<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="sectionalfisherNumberSelectDialog"
          max-width="800px"
          scrollable
          persistent
      >
        <v-card>
          <v-card-title></v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 600px">
            <v-data-table
                locale="jp"
                class="table overflow-y-auto elevation-1"
                v-model="sectionalfisherNumberSelect"
                :headers="headers"
                :items="selectItem"
                fixed-header
                :single-select="singleSelect"
                :mobile-breakpoint="0"
                item-key="number"
                show-select
                hide-default-footer
                disable-pagination
                calculate-widths
                @click:row="rowClick"
            >
              <!-- ヘッダの定義 -->
              <template v-slot:[`header.data-table-select`]></template>
              <template
                  v-slot:[`item.data-table-select`]="{ isSelected, select }"
              >
                <v-simple-checkbox
                    class="big-checkbox"
                    light
                    color="#0ddbc7"
                    :value="isSelected"
                    @input="select($event)"
                    :ripple="false"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn
                color="primary"
                style="font-size: 20px"
                class="ma-2"
                width="160"
                @click="sectionalfishernumberSelectClose"
                outlined
            >もどる
            </v-btn
            >
            <v-btn
                color="primary"
                style="font-size: 20px"
                class="ma-2"
                width="160"
                @click="sectionalfishernumberSelectApply"
            >決定
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["sectionalfisherNumberSelectDialog", "checkSeaArea", "sectionalfisherNumberSelectSub"],
  data() {
    this.sectionalfisherNumberSelect = [];
    this.selectItem = [];
    if (this.checkSeaArea != "") {
      // 区画漁業権番号の一覧情報の取得表示
      this.loadData(this.checkSeaArea);
    }
    return {
      // 単一選択設定
      singleSelect: false,
      // 一覧のヘッダ情報
      headers: [
        {
          text: "番号",
          align: "center",
          value: "number",
          width: "80",
          sortable: false,
          class: "grey darken-1 white--text",
        },
        {
          text: "名前",
          align: "start",
          value: "name",
          width: "",
          sortable: false,
          class: "grey darken-1 white--text",
        },
      ],
    };
  },
  methods: {
    /**
     * 区画漁業権番号の一覧情報を取得して表示する
     */
    loadData(checkSeaArea) {
      // 採取海域区分別に割り当てる区画漁業権番号の一覧情報
      let sectionalfishernums1 = [
        {
          number: '1',
          name: '鳴川１[くば]',
          classification: 'SPECIFIED',
        },
        {
          number: '2',
          name: '鳴川２[くば]',
          classification: 'SPECIFIED',
        },
        {
          number: '3',
          name: '平　根[くば]',
          classification: 'SPECIFIED',
        },
        {
          number: '4',
          name: '可部島（横レーン）[くば]',
          classification: 'SPECIFIED',
        },
        {
          number: '5',
          name: '可部島（縦レーン）[くば]',
          classification: 'SPECIFIED',
        },
        {
          number: '6',
          name: '廿日市市宮島町長浦ノ鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '7',
          name: '廿日市市宮島町長浦ノ鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '8',
          name: '廿日市市宮島町江ノ尻浦',
          classification: 'SPECIFIED',
        },
        {
          number: '21',
          name: '田　尻[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '22',
          name: 'ナタリー[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '23',
          name: 'ナタリー[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '24',
          name: '地御前[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '25',
          name: '空　筏[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '26',
          name: '放　卵[地御前]',
          classification: 'CONDITIONAL',
        },
        {
          number: '27',
          name: '廿日市市阿品１丁目，地御前５丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '28',
          name: '廿日市市地御前１丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '29',
          name: '廿日市市串戸１丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '31',
          name: '大国１[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '32',
          name: '大国２[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '33',
          name: '深　江[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '34',
          name: '一茶苑[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '35',
          name: '御床浦[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '36',
          name: '包ケ浦[大野]',
          classification: 'CONDITIONAL',
        },
        {
          number: '37',
          name: '廿日市市物見東１丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '38',
          name: '廿日市市宮島口西１丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '39',
          name: '廿日市市宮島町須屋浦',
          classification: 'SPECIFIED',
        },
        {
          number: '40',
          name: '廿日市市宮島町下谷',
          classification: 'SPECIFIED',
        },
        {
          number: '41',
          name: '廿日市市宮島町御床浦',
          classification: 'SPECIFIED',
        },
        {
          number: '42',
          name: '廿日市市宮島町大江浦',
          classification: 'SPECIFIED',
        },
        {
          number: '43',
          name: '廿日市市宮島町下室浜',
          classification: 'SPECIFIED',
        },
        {
          number: '44',
          name: '廿日市市宮島町上室浜，下室浜',
          classification: 'SPECIFIED',
        },
        {
          number: '45',
          name: '廿日市市宮島町多々良潟',
          classification: 'SPECIFIED',
        },
        {
          number: '51',
          name: '宮浜岡[大野町]',
          classification: 'CONDITIONAL',
        },
        {
          number: '52',
          name: '宮浜沖[大野町]',
          classification: 'CONDITIONAL',
        },
        {
          number: '53',
          name: 'サントリー[大野町]',
          classification: 'CONDITIONAL',
        },
        {
          number: '54',
          name: '南　西[大野町]',
          classification: 'SPECIFIED',
        },
        {
          number: '55',
          name: '焼　山[大野町]',
          classification: 'SPECIFIED',
        },
        {
          number: '56',
          name: '廿日市市宮島町須屋浦',
          classification: 'SPECIFIED',
        },
        {
          number: '57',
          name: '廿日市市宮島町下谷鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '58',
          name: '廿日市市宮島町御床浦',
          classification: 'SPECIFIED',
        },
        {
          number: '59',
          name: '廿日市市宮島町大川浦',
          classification: 'SPECIFIED',
        },
        {
          number: '63',
          name: '杉の浦[宮島]',
          classification: 'CONDITIONAL',
        },
        {
          number: '64',
          name: '包ケ浦[宮島]',
          classification: 'CONDITIONAL',
        },
        {
          number: '65',
          name: '鷹の巣[宮島]',
          classification: 'SPECIFIED',
        },
        {
          number: '66',
          name: '入　浜[宮島]',
          classification: 'SPECIFIED',
        },
        {
          number: '67',
          name: '大砂利[宮島]',
          classification: 'SPECIFIED',
        },
        {
          number: '68',
          name: '廿日市市宮島町小なきり',
          classification: 'SPECIFIED',
        },
        {
          number: '69',
          name: '廿日市市宮島町大なきり',
          classification: 'SPECIFIED',
        },
        {
          number: '70',
          name: '廿日市市宮島町米ケ浦',
          classification: 'SPECIFIED',
        },
        {
          number: '71',
          name: '廿日市市宮島町聖崎',
          classification: 'SPECIFIED',
        },
        {
          number: '72',
          name: '廿日市市宮島町聖崎',
          classification: 'SPECIFIED',
        },
        {
          number: '73',
          name: '廿日市市宮島町姥ケ懐',
          classification: 'SPECIFIED',
        },
        {
          number: '74',
          name: '廿日市市宮島町中崎',
          classification: 'SPECIFIED',
        },
        {
          number: '75',
          name: '廿日市市宮島町包ヶ浦',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums2 = [
        {
          number: '79',
          name: '吉見新開[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '80',
          name: '津久根島[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '81',
          name: '津久根島[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '82',
          name: '津久根島[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '83',
          name: '津久根島[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '84',
          name: '観音沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '85',
          name: '観音沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '86',
          name: '江波沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '87',
          name: '江波沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '88',
          name: '江波沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '89',
          name: '江波沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '90',
          name: '岩　根[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '91',
          name: '岩　根[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '92',
          name: '江波沖新[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '93',
          name: '金輪島西[広島市]',
          classification: 'NOT_SPECIFIED',
        },
        {
          number: '94',
          name: '金輪島北[広島市]',
          classification: 'NOT_SPECIFIED',
        },
        {
          number: '95',
          name: '金輪島東[広島市]',
          classification: 'NOT_SPECIFIED',
        },
        {
          number: '96',
          name: '峠島東側[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '97',
          name: '峠島西側[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '98',
          name: '峠島北側[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '99',
          name: 'かしら[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '100',
          name: '似島学園[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '101',
          name: '大黄沖[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '102',
          name: '大黄岡[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '103',
          name: '似島深浦[広島市]',
          classification: 'SPECIFIED',
        },
        {
          number: '104',
          name: '二　階[広島市]',
          classification: 'SPECIFIED',
        },
        {
          number: '105',
          name: '大　谷[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '106',
          name: '赤　石[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '107',
          name: '弁天島[広島市]',
          classification: 'CONDITIONAL',
        },
        {
          number: '108',
          name: '広島市西区観音新町４丁目（太田川放水路）',
          classification: 'SPECIFIED',
        },
        {
          number: '109',
          name: '広島市西区観音新町１丁目（天満川）',
          classification: 'SPECIFIED',
        },
        {
          number: '110',
          name: '広島市西区南観音8丁目（天満川）',
          classification: 'SPECIFIED',
        },
        {
          number: '111',
          name: '広島市南区似島町長谷',
          classification: 'SPECIFIED',
        },
        {
          number: '112',
          name: '広島市南区似島町大黄',
          classification: 'SPECIFIED',
        },
        {
          number: '113',
          name: '広島市南区似島町大黄',
          classification: 'SPECIFIED',
        },
        {
          number: '114',
          name: '広島市南区似島町外方鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '115',
          name: '広島市南区似島町外方鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '116',
          name: '広島市南区似島町深浦',
          classification: 'SPECIFIED',
        },
        {
          number: '117',
          name: '広島市南区似島町二階',
          classification: 'SPECIFIED',
        },
        {
          number: '118',
          name: '広島市南区似島町二階',
          classification: 'SPECIFIED',
        },
        {
          number: '129',
          name: 'かさなり[坂町]',
          classification: 'NOT_SPECIFIED',
        },
        {
          number: '130',
          name: '鯛　尾[坂町]',
          classification: 'NOT_SPECIFIED',
        },
        {
          number: '131',
          name: '亀　石[坂町]',
          classification: 'CONDITIONAL',
        },
        {
          number: '132',
          name: '福　浦[坂町]',
          classification: 'SPECIFIED',
        },
        {
          number: '133',
          name: '安芸郡坂町森山',
          classification: 'SPECIFIED',
        },
        {
          number: '134',
          name: '安芸郡坂町森山',
          classification: 'SPECIFIED',
        },
        {
          number: '135',
          name: '安芸郡坂町森山',
          classification: 'SPECIFIED',
        },
        {
          number: '138',
          name: '高　祖[三高]',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums3 = [
        {
          number: '139',
          name: '三　吉[三高]',
          classification: 'SPECIFIED',
        },
        {
          number: '140',
          name: '江田島市沖美町三吉',
          classification: 'SPECIFIED',
        },
        {
          number: '141',
          name: '江田島市沖美町三吉',
          classification: 'SPECIFIED',
        },
        {
          number: '143',
          name: '絵の島北[美能]',
          classification: 'CONDITIONAL',
        },
        {
          number: '144',
          name: '絵の島[美能]',
          classification: 'SPECIFIED',
        },
        {
          number: '145',
          name: '奈佐美[美能]',
          classification: 'SPECIFIED',
        },
        {
          number: '146',
          name: '亀　内[美能]',
          classification: 'SPECIFIED',
        },
        {
          number: '148',
          name: '美能漁港[美能]',
          classification: 'SPECIFIED',
        },
        {
          number: '156',
          name: '長浜沖[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '157',
          name: '長浜岡[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '158',
          name: '飛渡瀬[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '159',
          name: '中　町[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '160',
          name: '松ケ窪[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '161',
          name: '遠崎の鼻[内能美]',
          classification: 'SPECIFIED',
        },
        {
          number: '162',
          name: '江田島市大柿町飛渡瀬',
          classification: 'SPECIFIED',
        },
        {
          number: '163',
          name: '江田島市大柿町飛渡瀬高須新開',
          classification: 'SPECIFIED',
        },
        {
          number: '164',
          name: '江田島市大柿町飛渡瀬大盤新開',
          classification: 'SPECIFIED',
        },
        {
          number: '165',
          name: '江田島市能美町岡村新開，大柿町落走新開',
          classification: 'SPECIFIED',
        },
        {
          number: '166',
          name: '江田島市能美町中町坪崎',
          classification: 'SPECIFIED',
        },
        {
          number: '167',
          name: '江田島市能美町中町大あじろ',
          classification: 'SPECIFIED',
        },
        {
          number: '168',
          name: '江田島市能美町中町長瀬',
          classification: 'SPECIFIED',
        },
        {
          number: '169',
          name: '江田島市能美町中町胡川',
          classification: 'SPECIFIED',
        },
        {
          number: '170',
          name: '江田島市能美町石井新開',
          classification: 'SPECIFIED',
        },
        {
          number: '171',
          name: '江田島市能美町石井新開',
          classification: 'SPECIFIED',
        },
        {
          number: '172',
          name: '江田島市能美町高田南区船だまり',
          classification: 'SPECIFIED',
        },
        {
          number: '173',
          name: '江田島市能美町高田松ケ窪',
          classification: 'SPECIFIED',
        },
        {
          number: '174',
          name: '江田島市能美町高田湯田',
          classification: 'SPECIFIED',
        },
        {
          number: '175',
          name: '江田島市能美町高田遠崎',
          classification: 'SPECIFIED',
        },
        {
          number: '176',
          name: '江田島市能美町高田遠崎',
          classification: 'SPECIFIED',
        },
        {
          number: '177',
          name: '江田島市能美町高田遠崎',
          classification: 'SPECIFIED',
        },
        {
          number: '178',
          name: '江田島市能美町高田とうあみだ',
          classification: 'SPECIFIED',
        },
        {
          number: '221',
          name: '二つ小島[東江]',
          classification: 'SPECIFIED',
        },
        {
          number: '229',
          name: '松ケ鼻[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '230',
          name: '鷲　部[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '231',
          name: '江田大原[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '232',
          name: '竹ノ下[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '233',
          name: '江　関[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '235',
          name: '江田島市江田島町鷲部',
          classification: 'SPECIFIED',
        },
        {
          number: '236',
          name: '江田島市江田島町宮の原',
          classification: 'SPECIFIED',
        },
        {
          number: '237',
          name: '江田島市江田島町津久茂',
          classification: 'SPECIFIED',
        },
        {
          number: '238',
          name: '江田島市江田島町津久茂',
          classification: 'SPECIFIED',
        },
        {
          number: '239',
          name: '江田島市江田島町大須',
          classification: 'SPECIFIED',
        },
        {
          number: '240',
          name: '江田島市江田島町切串',
          classification: 'SPECIFIED',
        },
        {
          number: '241',
          name: '幸の浦[切串]',
          classification: 'SPECIFIED',
        },
        {
          number: '242',
          name: '江　関[切串]',
          classification: 'SPECIFIED',
        },
        {
          number: '243',
          name: '中学校前[切串]',
          classification: 'SPECIFIED',
        },
        {
          number: '244',
          name: '神が浦鼻[切串]',
          classification: 'SPECIFIED',
        },
        {
          number: '245',
          name: '江田島市江田島町江関',
          classification: 'SPECIFIED',
        },
        {
          number: '246',
          name: '江田島市江田島町江関',
          classification: 'SPECIFIED',
        },
        {
          number: '247',
          name: '江田島市江田島町切串東新開',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums4 = [
        {
          number: '10',
          name: '猪子島西[阿多田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '11',
          name: '猪子島東[阿多田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '12',
          name: '大竹市阿多田島うどまり',
          classification: 'SPECIFIED',
        },
        {
          number: '13',
          name: '大竹市阿多田島内深浦',
          classification: 'SPECIFIED',
        },
        {
          number: '14',
          name: '大竹市阿多田島内深浦',
          classification: 'SPECIFIED',
        },
        {
          number: '15',
          name: '大竹市阿多田島内深浦',
          classification: 'SPECIFIED',
        },
        {
          number: '16',
          name: '大竹市阿多田島内深浦',
          classification: 'SPECIFIED',
        },
        {
          number: '147',
          name: '大黒神島，黒山[美能]',
          classification: 'SPECIFIED',
        },
        {
          number: '179',
          name: '大　矢[鹿川]',
          classification: 'SPECIFIED',
        },
        {
          number: '180',
          name: '鎌　木[鹿川]',
          classification: 'SPECIFIED',
        },
        {
          number: '181',
          name: '黒神深浦[鹿川]',
          classification: 'SPECIFIED',
        },
        {
          number: '182',
          name: '江田島市能美町鹿川大矢',
          classification: 'SPECIFIED',
        },
        {
          number: '183',
          name: '江田島市能美町鹿川大矢',
          classification: 'SPECIFIED',
        },
        {
          number: '184',
          name: '江田島市能美町鹿川',
          classification: 'SPECIFIED',
        },
        {
          number: '185',
          name: '江田島市能美町鹿川文久新開',
          classification: 'SPECIFIED',
        },
        {
          number: '186',
          name: '小古江[大原]',
          classification: 'SPECIFIED',
        },
        {
          number: '187',
          name: '深江大附[大原]',
          classification: 'SPECIFIED',
        },
        {
          number: '189',
          name: '江田島市大柿町小古江',
          classification: 'SPECIFIED',
        },
        {
          number: '190',
          name: '江田島市大柿町小古江',
          classification: 'SPECIFIED',
        },
        {
          number: '192',
          name: '崖の下[深江]',
          classification: 'SPECIFIED',
        },
        {
          number: '193',
          name: '片山鼻[深江]',
          classification: 'SPECIFIED',
        },
        {
          number: '194',
          name: '沖野島[深江]',
          classification: 'SPECIFIED',
        },
        {
          number: '195',
          name: '白　水[深江]',
          classification: 'SPECIFIED',
        },
        {
          number: '196',
          name: '江田島市大柿町深江大附ガンコウジ',
          classification: 'SPECIFIED',
        },
        {
          number: '197',
          name: '江田島市沖美町大黒神島深浦',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums5 = [
        {
          number: '188',
          name: '大　原[大原]',
          classification: 'SPECIFIED',
        },
        {
          number: '201',
          name: '大　原[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '202',
          name: '黒　嶽[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '203',
          name: '臼ケ浦[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '204',
          name: '明神鼻[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '205',
          name: '大　君[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '206',
          name: '引　島[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '207',
          name: '柿浦漁港[大柿町]',
          classification: 'SPECIFIED',
        },
        {
          number: '208',
          name: '江田島市大柿町大君坪土',
          classification: 'SPECIFIED',
        },
        {
          number: '209',
          name: '江田島市大柿町大君中の鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '210',
          name: '江田島市大柿町大君中の鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '211',
          name: '江田島市大柿町大君王泊',
          classification: 'SPECIFIED',
        },
        {
          number: '212',
          name: '江田島市大柿町大君源八鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '213',
          name: '江田島市大柿町大君',
          classification: 'SPECIFIED',
        },
        {
          number: '214',
          name: '江田島市大柿町大君コシマ鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '215',
          name: '江田島市大柿町大君明神鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '216',
          name: '江田島市大柿町大君',
          classification: 'SPECIFIED',
        },
        {
          number: '217',
          name: '江田島市大柿町柿浦三束新開',
          classification: 'SPECIFIED',
        },
        {
          number: '218',
          name: '江田島市大柿町柿浦',
          classification: 'SPECIFIED',
        },
        {
          number: '222',
          name: '高須浜[東江]',
          classification: 'SPECIFIED',
        },
        {
          number: '223',
          name: 'ももだか[東江]',
          classification: 'SPECIFIED',
        },
        {
          number: '224',
          name: '鳥ノ首[東江]',
          classification: 'SPECIFIED',
        },
        {
          number: '225',
          name: '若　宮[東江]',
          classification: 'CONDITIONAL',
        },
        {
          number: '226',
          name: '秋　月[東江]',
          classification: 'SPECIFIED',
        },
        {
          number: '227',
          name: '江田島市江田島町鷲部ひるがさこ',
          classification: 'SPECIFIED',
        },
        {
          number: '228',
          name: '江田島市江田島町江南',
          classification: 'SPECIFIED',
        },
        {
          number: '234',
          name: 'ももだか[江田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '262',
          name: '猿ケ鼻[田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '263',
          name: '下大田[田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '264',
          name: '田原北[田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '265',
          name: '田原南[田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '266',
          name: '呉市音戸町田原猿ヶ鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '267',
          name: '呉市音戸町田原',
          classification: 'SPECIFIED',
        },
        {
          number: '268',
          name: '呉市音戸町田原俵石',
          classification: 'SPECIFIED',
        },
        {
          number: '269',
          name: '呉市音戸町田原',
          classification: 'SPECIFIED',
        },
        {
          number: '271',
          name: '流　田[早瀬]',
          classification: 'SPECIFIED',
        },
        {
          number: '272',
          name: '藤の脇[早瀬]',
          classification: 'SPECIFIED',
        },
        {
          number: '273',
          name: '呉市音戸町早瀬ホーシ鼻',
          classification: 'SPECIFIED',
        },
        {
          number: '274',
          name: '呉市音戸町早瀬下流田',
          classification: 'SPECIFIED',
        },
        {
          number: '275',
          name: '呉市音戸町早瀬サタメの埋立地北側',
          classification: 'SPECIFIED',
        },
        {
          number: '276',
          name: '本　浦[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '277',
          name: '本浦新[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '278',
          name: '重　生[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '279',
          name: '重　極[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '280',
          name: '光ケ瀬[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '281',
          name: '宇和木[倉橋西部]',
          classification: 'SPECIFIED',
        },
        {
          number: '282',
          name: '呉市倉橋町重極',
          classification: 'SPECIFIED',
        },
        {
          number: '283',
          name: '呉市倉橋町宇和木',
          classification: 'SPECIFIED',
        },
        {
          number: '308',
          name: '天　応[吉浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '309',
          name: '汐見町[吉浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '310',
          name: '狩留賀[吉浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '311',
          name: '呉市天応大浜２丁目',
          classification: 'SPECIFIED',
        },
      ];
      let sectionalfishernums6 = [
        {
          number: '136',
          name: '呉市仁方本町３丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '248',
          name: 'あじわ[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '249',
          name: 'あじわ[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '250',
          name: '小学校[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '251',
          name: '波多見[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '252',
          name: '大浦崎[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '253',
          name: '小情島[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '254',
          name: '赤崎鼻[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '255',
          name: '西新開[音戸]',
          classification: 'SPECIFIED',
        },
        {
          number: '257',
          name: '呉市音戸町波多見',
          classification: 'SPECIFIED',
        },
        {
          number: '258',
          name: '呉市音戸町波多見田ノ浦',
          classification: 'SPECIFIED',
        },
        {
          number: '259',
          name: '呉市音戸町畑区',
          classification: 'SPECIFIED',
        },
        {
          number: '270',
          name: '呉市安浦町大泊新開',
          classification: 'SPECIFIED',
        },
        {
          number: '285',
          name: '長　谷[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '286',
          name: '倉橋弁天[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '287',
          name: 'トロブ[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '288',
          name: '脇　田[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '289',
          name: '洲の崎[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '290',
          name: '飛路井[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '291',
          name: '亀ケ首[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '292',
          name: '鹿老渡[倉橋島]',
          classification: 'SPECIFIED',
        },
        {
          number: '293',
          name: '呉市倉橋町大江',
          classification: 'SPECIFIED',
        },
        {
          number: '294',
          name: '呉市倉橋町大江',
          classification: 'SPECIFIED',
        },
        {
          number: '295',
          name: '呉市倉橋町長谷',
          classification: 'SPECIFIED',
        },
        {
          number: '296',
          name: '呉市倉橋町トロブ',
          classification: 'SPECIFIED',
        },
        {
          number: '297',
          name: '呉市倉橋町先田',
          classification: 'SPECIFIED',
        },
        {
          number: '298',
          name: '呉市倉橋町洲の崎',
          classification: 'SPECIFIED',
        },
        {
          number: '299',
          name: '呉市倉橋町大尻郷',
          classification: 'SPECIFIED',
        },
        {
          number: '302',
          name: '上黒島[下蒲刈町]',
          classification: 'SPECIFIED'
        },
        {
          number: '303',
          name: '呉市下蒲刈町塩浜新開',
          classification: 'SPECIFIED',
        },
        {
          number: '313',
          name: '阿賀沖[阿賀]',
          classification: 'CONDITIONAL',
        },
        {
          number: '314',
          name: '小情新漁場[阿賀]',
          classification: 'SPECIFIED',
        },
        {
          number: '315',
          name: '情の漁場[阿賀]',
          classification: 'SPECIFIED',
        },
        {
          number: '316',
          name: '呉市阿賀南１丁目',
          classification: 'SPECIFIED',
        },
        {
          number: '321',
          name: '虹村沖[広]',
          classification: 'CONDITIONAL',
        },
        {
          number: '322',
          name: '長浜沖[広]',
          classification: 'CONDITIONAL',
        },
        {
          number: '323',
          name: '呉市阿賀南１丁目（黒瀬川）',
          classification: 'SPECIFIED',
        },
        {
          number: '324',
          name: '呉市広多賀谷２丁目（黒瀬川）',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums7 = [
        {
          number: '330',
          name: '前　灘[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '331',
          name: 'ノノウラ[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '332',
          name: '柏　島[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '333',
          name: '小日之浦[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '334',
          name: '呉市安浦町三津口日之浦',
          classification: 'SPECIFIED',
        },
        {
          number: '335',
          name: '呉市安浦町三津口日之浦亀戸新開',
          classification: 'SPECIFIED',
        },
        {
          number: '336',
          name: '呉市安浦町三津口日之浦亀戸新開',
          classification: 'SPECIFIED',
        },
        {
          number: '337',
          name: '呉市安浦町水尻しょうろ新開，水尻新開',
          classification: 'SPECIFIED',
        },
        {
          number: '338',
          name: '呉市安浦町水尻しょうろ新開',
          classification: 'SPECIFIED',
        },
        {
          number: '339',
          name: 'しょうろ新開[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '340',
          name: '呉市安浦町三津口子の浦新開',
          classification: 'SPECIFIED',
        },
        {
          number: '341',
          name: '子の浦新開[安浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '344',
          name: '海水浴[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '345',
          name: '学校前[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '346',
          name: '小松原[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '347',
          name: '小松原[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '348',
          name: '観音浜[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '349',
          name: '干拓地[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '350',
          name: '龍王島[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '351',
          name: '沖の鼻[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '352',
          name: '大芝中[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '353',
          name: '真珠後[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '354',
          name: '大芝西[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '355',
          name: '大芝新[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '356',
          name: '東広島市安芸津町小松原',
          classification: 'SPECIFIED',
        },
        {
          number: '357',
          name: '東広島市安芸津町小松原',
          classification: 'SPECIFIED',
        },
        {
          number: '358',
          name: '東広島市安芸津町小松原',
          classification: 'SPECIFIED',
        },
        {
          number: '359',
          name: '東広島市安芸津町風早観音浜干拓地',
          classification: 'SPECIFIED',
        },
        {
          number: '360',
          name: '東広島市安芸津町風早観音浜干拓地',
          classification: 'SPECIFIED',
        },
        {
          number: '361',
          name: '東広島市安芸津町風早安芸津干拓地',
          classification: 'SPECIFIED',
        },
        {
          number: '362',
          name: '前田沖[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '363',
          name: '木　谷[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '364',
          name: '皇后石[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '365',
          name: 'ホボロ[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '366',
          name: '伝　導[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '367',
          name: '三　津[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '368',
          name: '藍之島[安芸津]',
          classification: 'SPECIFIED',
        },
        {
          number: '369',
          name: '東広島市安芸津町木谷',
          classification: 'SPECIFIED',
        },
        {
          number: '370',
          name: '沖の鼻[早田原]',
          classification: 'SPECIFIED',
        },
        {
          number: '371',
          name: '東広島市安芸津町木谷小宿根',
          classification: 'SPECIFIED',
        },
        {
          number: '372',
          name: '東広島市安芸津町木谷大宿根',
          classification: 'SPECIFIED',
        },
        {
          number: '373',
          name: '東広島市安芸津町木谷二馬手',
          classification: 'SPECIFIED',
        },
        {
          number: '374',
          name: '東広島市安芸津町木谷二馬手',
          classification: 'SPECIFIED',
        },
        {
          number: '375',
          name: '東広島市安芸津町藍之島',
          classification: 'SPECIFIED',
        },
        {
          number: '376',
          name: '城ケ浜[大崎内浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '377',
          name: '長　島[大崎内浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '378',
          name: '月ノ浦[大崎内浦]',
          classification: 'SPECIFIED',
        },
        {
          number: '383',
          name: '竹原市吉名町宗越',
          classification: 'SPECIFIED',
        },
        {
          number: '384',
          name: '竹原市吉名町柏',
          classification: 'SPECIFIED',
        }
      ];
      let sectionalfishernums8 = [
        {
          number: '309',
          name: '上江府島[向島]',
          classification: 'SPECIFIED',
        },
        {
          number: '401',
          name: '尾道市向島町串山',
          classification: 'SPECIFIED',
        },
        {
          number: '405',
          name: '田　尻[田尻あんずの里]',
          classification: 'SPECIFIED',
        },
        {
          number: '406',
          name: '田　尻[田尻あんずの里]',
          classification: 'SPECIFIED',
        },
        {
          number: '415',
          name: '走　島[走島]',
          classification: 'SPECIFIED',
        },
        {
          number: '417',
          name: '能登原小桜[千年]',
          classification: 'SPECIFIED',
        },
        {
          number: '418',
          name: '能登原小桜[千年]',
          classification: 'SPECIFIED',
        },
        {
          number: '419',
          name: '横田漁港[横島]',
          classification: 'SPECIFIED',
        },
        {
          number: '421',
          name: '横島志垣[横島]',
          classification: 'SPECIFIED',
        },
        {
          number: '422',
          name: '横島入双[横島]',
          classification: 'SPECIFIED',
        },
        {
          number: '423',
          name: '福山市内海町横島防地',
          classification: 'SPECIFIED',
        },
        {
          number: '435',
          name: '田島矢ノ島[田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '436',
          name: '田島牛ノ首[田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '437',
          name: '田島内浦[田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '438',
          name: '田島内浦[田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '439',
          name: '田島小箱[田島]',
          classification: 'SPECIFIED',
        },
        {
          number: '440',
          name: '福山市内海町田島釜谷',
          classification: 'SPECIFIED',
        }
      ];
      // 指定した採取海域区分に関する区画漁業権番号の一覧情報の割り当て
      switch (checkSeaArea) {
        case 1:
          this.selectItem = sectionalfishernums1;
          break;
        case 2:
          this.selectItem = sectionalfishernums2;
          break;
        case 3:
          this.selectItem = sectionalfishernums3;
          break;
        case 4:
          this.selectItem = sectionalfishernums4;
          break;
        case 5:
          this.selectItem = sectionalfishernums5;
          break;
        case 6:
          this.selectItem = sectionalfishernums6;
          break;
        case 7:
          this.selectItem = sectionalfishernums7;
          break;
        case 8:
          this.selectItem = sectionalfishernums8;
          break;
        default:
          break;
      }
      // 既選択情報クリア
      if (this.sectionalfisherNumberSelectSub) {
        this.sectionalfisherNumberSelect = this.sectionalfisherNumberSelectSub;
      } else {
        this.sectionalfisherNumberSelect = [];
      }
    },
    rowClick: function (item, row) {
      row.select(!row.isSelected);
    },
    /**
     * 区画漁業権番号選択
     */
    updateSectionalfishernumberSelect(sectionalfisherNumberSelect) {
      this.$emit("on-sectionalfisherNumber-select", sectionalfisherNumberSelect);
    },
    /**
     * 区画漁業権番号選択画面を閉じる
     */
    sectionalfishernumberSelectClose() {
      this.sectionalfisherNumberSelectDlg = false;
    },
    /**
     * 区画漁業権番号選択内容を区画漁業権番号に反映する
     */
    sectionalfishernumberSelectApply() {
      this.updateSectionalfishernumberSelect(this.sectionalfisherNumberSelect);
      this.sectionalfishernumberSelectClose();
    },
  },
  computed: {
    // 区画漁業権番号選択画面表示非表示用パラメータ制御用(props値変更対策)
    sectionalfisherNumberSelectDlg: {
      get() {
        return this.sectionalfisherNumberSelectDialog;
      },
      set(newVal) {
        this.$emit("on-sectionalfisherNumber-selected", newVal);
      }
    }
  }
};
</script>

<style scoped>
.table >>> th {
  font-size: 24px !important;
}

.table >>> tr > td {
  font-size: 24px !important;
}

th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}

th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}

.big-checkbox {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
</style>
